import React from 'react'

const Prevencion = ({iconContactoMasculino}) => {
   return (
      <>
         <div className="bg-latitud animated fadeIn" style={{"margin-bottom":"30px"}}>
            <div className="container section center white-text">
               <h5>
                  <strong>Prevención</strong>
               </h5>
            </div>
         </div>
         <div className="row">
            <div className="col s12 m12 l6 x6">
               <div className="card-panel grey lighten-5 z-depth-1">
                  <div className="row valign-wrapper">
                     <div className="col s2">
                        <img src={iconContactoMasculino} alt="" className="circle responsive-img"/>
                     </div>
                     <div className="col s10">
                     <span className="black-text">
                        <strong>Lic. Matias Saravia</strong><br/>
                        0388 - 156 039 076<br/>
                        0388 - 4911741 Int.: 155<br/>
                        msaravia@latitudsursa.com.ar
                     </span>
                     </div>
                  </div>
               </div>
            </div>
            <div className="col s12 m12 l6 x6">
               <div className="card-panel grey lighten-5 z-depth-1">
                  <div className="row valign-wrapper">
                     <div className="col s2">
                        <img src={iconContactoMasculino} alt="" className="circle responsive-img"/>
                     </div>
                     <div className="col s10">
                        <span className="black-text">
                           <strong>Lic. Elian Cardozo</strong><br/>
                           0388 - 156 039 074<br/>
                           0388 - 4911741 Int.: 153<br/>
                           ecardozo@latitudsursa.com.ar
                        </span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div className="row">
            <div className="col s12 m12 l6 x6">
               <div className="card-panel grey lighten-5 z-depth-1">
                  <div className="row valign-wrapper">
                     <div className="col s2">
                        <img src={iconContactoMasculino} alt="" className="circle responsive-img"/>
                     </div>
                     <div className="col s10">
                     <span className="black-text">
                        <strong>Lic. Mariano Aramayo</strong><br/>
                        0388 - 156 039 075<br/>
                        maramayo@latitudsursa.com.ar
                     </span>
                     </div>
                  </div>
               </div>
            </div>
            <div className="col s12 m12 l6 x6">
               <div className="card-panel grey lighten-5 z-depth-1">
                  <div className="row valign-wrapper">
                     <div className="col s2">
                        <img src={iconContactoMasculino} alt="" className="circle responsive-img"/>
                     </div>
                     <div className="col s10">
                        <span className="black-text">
                           <strong>Lic. Alberto López</strong><br/>
                           0388 - 154 337 133<br/>
                           art.prevencion@latitudsursa.com.ar
                        </span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div className="row">
            <div className="col s12 m12 l6 x6">
               <div className="card-panel grey lighten-5 z-depth-1">
                  <div className="row valign-wrapper">
                     <div className="col s2">
                        <img src={iconContactoMasculino} alt="" className="circle responsive-img"/>
                     </div>
                     <div className="col s10">
                     <span className="black-text">
                        <strong>Tec. Gabriel Martinez</strong><br/>
                        0388 - 154 420 892<br/>
                        0388 - 4911741 Int.: 156<br/>
                        gmartinez@latitudsursa.com.ar
                     </span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </>
   )
}

export default Prevencion